module.exports = __webpack_public_path__ + "static/neidi_yewu.411fb3fd.jpg";